import React from "react";
import { useNavigate } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { Bell } from "lucide-react"; // نفس مكتبة الأيقونات بتاعتك
import { Badge } from "react-bootstrap";
import { getUnreadNotificationsCount } from "../../services/userService"; // تأكد من المسار

export default function NotificationBell() {
  const navigate = useNavigate();

  // 🔥 React Query: جلب البيانات وتحديثها كل 60 ثانية
  const { data: count = 0 } = useQuery({
    queryKey: ["unreadNotifications"], // مفتاح الكاش
    queryFn: getUnreadNotificationsCount, // دالة الـ API
    refetchInterval: 60000, // تحديث كل دقيقة
    refetchOnWindowFocus: true, // تحديث لما ترجع تفتح التاب
    staleTime: 55000, // البيانات تعتبر قديمة بعد 59 ثانية
    retry: false, // بلاش محاولات كتير لو السيرفر واقع
  });
  return (
    <div
      className="position-relative d-inline-flex align-items-center justify-content-center"
      onClick={() => navigate("/user/notifications")}
      style={{ cursor: "pointer", width: "40px", height: "40px" }} // مساحة للنقر
      title="Notifications"
    >
      {/* أيقونة الجرس */}
      <Bell 
        size={22} 
        style={{ color: "#007bff", transition: "transform 0.2s" }} 
        className="bell-icon"
      />

      {/* العداد (يظهر فقط لو فيه إشعارات) */}
      {count > 0 && (
        <Badge
          pill
          bg="danger"
          className="position-absolute top-0 start-100 translate-middle border border-light"
          style={{
            fontSize: "0.65rem",
            padding: "0.3em 0.5em",
            transform: "translate(-50%, 5%)", // تظبيط مكان العداد بدقة
            minWidth: "18px"
          }}
        >
          {count > 99 ? "99+" : count}
        </Badge>
      )}

      {/* تأثير بسيط لما الماوس يقف عليه */}
      <style>{`
        .bell-icon:hover {
          transform: scale(1.1);
          color: #0056b3 !important;
        }
      `}</style>
    </div>
  );
}